import { render } from "./Cover.vue?vue&type=template&id=c248bd02&scoped=true"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"

import "./Cover.vue?vue&type=style&index=0&id=c248bd02&scoped=true&lang=css"

import exportComponent from "/Users/yinhu/code/jugu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c248bd02"]])

export default __exports__